export const colors = {
  primary: 'rgb(241, 121, 0)',
  secondary: 'rgb(44, 49, 68)',
  error: 'rgb(176, 0, 32)',
  white: 'rgb(255, 255, 255)',
  smokeWhite: 'rgb(241,242,246)',
  darkGray: 'rgb(122,122,122)',
  gray: 'rgb(171,174,177)',
  silver: 'rgb(110, 110, 110)',
  lavender: 'rgb(233,234,236)',
  darkBlue: 'rgb(0, 19, 94)',
  lightGray: 'rgb(221, 223, 228)',
  peach: 'rgb(254, 241, 229)',
  dark: 'rgb(38, 50, 56)',
  black: 'rgb(0, 0, 0)',
  hoverLightGray: 'rgb(246,246,246)',
  lightOrange: 'rgb(251, 215, 178)',
  lightOrange1: 'rgb(251, 215, 178, 1)',
  mediumOrange: 'rgb(255, 154, 108, 1)',
  milkyWhite: 'rgb(238, 233, 219)',
  blueGray: 'rgb(175, 180, 198)',
  nightRider: 'rgb(52, 51, 51)',
  orangeGrey: 'rgb(255, 179, 102)',
  backLight: 'rgb(240, 241, 241)',
  cloud: 'rgba(235, 235, 235, 1)',
  darkCloud: 'rgba(216, 216, 216, 1)',
  cloudGrey: 'rgba(151, 163, 183, 1)',
  tretinary: 'rgba(254, 195, 135, 1)',
  whiteOrange: 'rgba(238, 233, 219, 1)',
  gradientGray:
    'linear-gradient(90deg, #343333 38.05%, #484848 69.22%, #282828 98.98%)',
  gradientLightGray:
    'linear-gradient(180deg, #d0d0d0 0%, rgba(240, 241, 241, 0.5) 100%)',
  gradientAzure:
    'linear-gradient(to right, rgba(25, 115, 112, 1), rgba(26, 237, 224, 1))',
  gradientGreen: `linear-gradient(
      90deg,
      rgb(37, 217, 114) 60%,
      rgb(71, 185, 252) 100%
    )`,
  bottomGradientGray:
    'linear-gradient(to bottom, rgba(51, 51, 51, 0), rgba(51, 51, 51, 0.8), rgb(52, 51, 51))',
  aquaBlue: 'rgb(97, 218, 251)',
} as const

export const newColors = {
  accent: '#F17900',
  secondary: '#FFB366',
  tertiary: '#FEC387',
  orange: '#FBD7B2',
  errorGrayBG: '#FD7878',
  errorWhiteBG: '#DB0000',
  white: '#FFFFFF',
  lightOrange: '#EEE9DB',
  mediumOrange: '#FFD8B1',
  veryLightOrange: '#FFE7CF',
  paleOrange: '#FFF1E3',
  primary: '#2C3144',
  dark: '#393939',
  coldGray: '#EBEBEB',
  lightGray: '#F0F1F1',
  hoverLightGray: '#F6F6F6',
  darkGray: '#6E6E6E',
  gray: '#898989',
  grayOnHover: '#979797',
  navyBlue: '#0F2A8D',
  blue: '#314E85',
  lightBlue: '#E7E7E7',
  error1: '#FD7878',
  error2: '#DB0000',
  smoky: '#181818',
  blueGray: '#8692a6',
  overlay: '#00000099',
  gradientGray:
    'linear-gradient(90deg, #343333 38.05%, #484848 69.22%, #282828 98.98%)',
  gradientOrange: 'linear-gradient(90deg, #F3AF6A 25.6%, #F17900 100%);',
  gradientBlue: 'linear-gradient(90deg, #79798D 38.05%, #101017 98.98%)',
  gradientGreen: 'linear-gradient(90.99deg, #25D972 54.68%, #47B9FC 91.13%)',
  grayLine: '#DBDBDB',
  gradientGrayCenter:
    'linear-gradient(90deg, #282828 -10.26%, #6e6e6e 51.55%, #282828 117.1%)',
  placeholderLightGrey:
    'data:image/webp;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP88PHjfwAJfgPTrVauHQAAAABJRU5ErkJggg==',
  gradientLightGray:
    'linear-gradient(0deg, rgba(27, 27, 27, 1) 0%, rgba(27, 27, 27, 0.7) 80%, rgba(255, 255, 255, 0) 100%)',
  gradientDarkGray:
    'linear-gradient(90deg,#343333 14.79%,#474747 50.57%,#282828 66.78%)',
  gradientGrayRight:
    'linear-gradient(90deg, #343333 38.05%, rgba(40, 40, 40, 0.75) 69.22%, #282828 98.98%)',
} as const
